import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import reduxUtils from 'util/redux';

import t, { Trans } from 'translations';
import MigrosLoginButton from 'components/migros-login-button';
import ErrorImageEmpty from 'components/error-image/empty/';

function Loggedout() {
    return (
        <div className="cart--empty-content">
            <h2 className="u-reset cart--empty-title">
                <Trans path={'cart.empty_authenticated_title'} />
            </h2>
            <p className="cart--empty-text">
                <Trans path={'cart.empty_authenticated_text'} />
            </p>
            <div className="cart--empty-login">
                <MigrosLoginButton inline={true} big={true} />
            </div>
        </div>
    );
}

function Loggedin() {
    return (
        <div className="cart--empty-content">
            <p className="cart--empty-text">
                <Trans path={'cart.empty_default_text'} />
            </p>
        </div>
    );
}

class CartEmpty extends PureComponent {
    static propTypes = {
        isAuthenticated: PropTypes.bool.isRequired,
    }

    render() {
        const { isAuthenticated } = this.props;

        return (
            <div className="cart--empty">
                <ErrorImageEmpty alt={t('cart.empty_default_text')} className="cart--empty-img" />
                {isAuthenticated ? <Loggedin /> : <Loggedout />}
            </div>
        );
    }
}

export default connect(
    reduxUtils.mapStateToProps({
        isAuthenticated: 'user.isAuthenticated',
    })
)(CartEmpty);



// WEBPACK FOOTER //
// ./mcart/assets/src/js/app/components/cart/empty/index.js